import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';

export interface Props {
  className?: string;
  color?: string;
}

class Divider extends React.Component<Props> {
  public static defaultProps = {
    color: colors.grey700,
  };

  public render() {
    const { className, color } = this.props;
    return (
      <svg viewBox="0 0 1 32" version="1.1" className={className} fill={color}>
        <g>
          <rect x="0" y="0" width="1" height="32" />
        </g>
      </svg>
    );
  }
}

const StyledDivider = styled(Divider)`
  width: 1px;
  height: 32px;
  padding: 0 15px;
`;

export default StyledDivider;
